<template>
  <a-form-item label="批次">
    <!-- <a-select :style="{width:type=='select'?'180px':'100%'}" @change="change" v-model:value="batchSn" :mode="mode" placeholder='请选择批次'>
      <a-select-option value="" v-if="type=='select'">全部</a-select-option>
      <a-select-option v-for='item in list' :value="item.batch_sn" :key='item.batch_sn'>{{item.batch_sn}}
      </a-select-option>
    </a-select> -->
    <ul style="min-width:334px;min-height:34px;border:1px solid #d9d9d9;border-radius:2px;padding:4px 4px 0 4px;position: relative;" @click="addSubmit">
      <span style="position: absolute;top:50%; transform:translateY(-50%);left:10px;color:#d5c5bf" v-show="allGoods.length==0">请选择批次</span>
      <li style="text-align:center;background:#f5f5f5;height:100%;padding:0 10px;border-radius:4px;margin-bottom:3px" class="ds-i-b m-r-5" v-for="item in allGoods" :key="item.id"><span style="font-size:12px;margin-right:4px">{{item.batch_sn}}</span><span class="s_shou" @click.stop="close(item)">x</span></li>
    </ul>
  </a-form-item>

  <a-modal :keyboard="false" title="选择批次" centered v-model:visible="visible" :footer="null" width="1000px">
    <a-form ref='form' :model='search' :style="{'marginBottom':'15px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="批次" name='batch_sn'>
        <a-input v-model:value="search.batch_sn" style="width:200px" placeholder="请输入批次号进行搜索"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='listData'>
      <template v-slot:action="{ record }">
        <a-button type="primary" href="javascript:;" @click="selectGoods(record)" :ghost="!record.checked">{{record.checked?'已选择':'选择'}}</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" :show-total="total => `总数: ${total} `" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
        <div style="display: flex;justify-content: center;">
           <a-button type="primary" href="javascript:;" @click="visible=false" >确定</a-button>
        </div>
  </a-modal>
</template>

<script>
import { code_batchs } from "@/api/qrcode";
import { onMounted, reactive, ref, toRefs, watch } from "vue";
import { iscode } from "@/utils/app";
const def = {
  page: 1,
  limit: 10,
  app_type: "",
  batch_sn: "",
  start_time: "",
  end_time: "",
};
let columns = [
  {
    title: "批次",
    dataIndex: "batch_sn",
    key: "batch_sn",
  },
  {
    title: "码类型",
    dataIndex: "scenario_type_title",
    key: "scenario_type_title",
  },
  {
    title: "流水号区间",
    dataIndex: "small_serial",
    key: "small_serial",
    customRender: ({ text, record }) => {
      return record.small_serial_start + "-" + record.small_serial_end;
    },
  },
  {
    title: "数量",
    dataIndex: "small_code_counts",
    key: "small_code_counts",
  },

  {
    title: "添加时间",
    dataIndex: "created_time",
    key: "created_time",
  },

  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  props: {
    batch_sn: String,
    type: String,
    mode: {
      type: String,
      default() {
        return "";
      },
    },
  },
  name: "normalBatchs",
  setup(props, { emit }) {
    const state = reactive({
      visible: false,
      listData: [],
      listLoading: false,
      total: 0,
      allGoods: [],
      allGoodsBatchSn: [],
    });

    const search = ref({ ...def });

    const list = ref([]);
    const batchSn = ref();
    const getCodeBatchsOptions = async () => {
      // let res = await code_batchs().then((res) => res.data);
      // if (iscode(res)) {
      //   list.value = res.data;
      // }
    };
    let watcher = watch(props, () => {
      // if (props.batch_sn) {
      //   if (!watcher) return;
      //   batchSn.value = props.batch_sn;
      //   watcher = null;
      // }
    });
    const change = (e) => {
      // if (e instanceof Array) {
      //   var batchs = []
      //   list.value.forEach(element => {
      //     e.forEach(v => {
      //       if (v == element.batch_sn) {
      //         batchs.push(element)
      //       }
      //     })
      //   });
      //   emit("change", batchs);
      // } else {
      //   list.value.forEach(element => {
      //     if (element.batch_sn == e) {
      //       emit("change", element);
      //     }
      //   });
      // }
      // emit("update:value", e);
    };

    //
    const initData = async () => {
      state.listLoading = true;
      let res = await code_batchs(search.value).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        state.listData = res.data;
        state.total = res.meta.total;
        is_select();
      }
      state.listLoading = false;
    };

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };

    const addSubmit = function () {
      initData(search.value);
      state.visible = true;
    };

    const selectGoods = function (item) {
      item.checked = !item.checked;
      if(item.checked){
        state.allGoods.push(item);
        state.allGoodsBatchSn.push(item.batch_sn);
      }else{
        var index;
        state.allGoods.forEach((v,k)=>{
          if(v.batch_sn==item.batch_sn){
              index=k
          }
        })
        state.allGoods.splice(index,1)
        state.allGoodsBatchSn.splice(index,1)
      }

      emit("change", state.allGoods);
      // emit("update:value", state.allGoods);
    };
    const is_select = function () {
      state.allGoods.forEach((v, i) => {
        state.listData.forEach((k, j) => {
          if (v.id == k.id) {
            k.checked = true;
          }
        });
      });
    };
    const close = function (data) {
      // console.log(id)
      state.allGoods.forEach((v, i) => {
        if (v.id == data.id) {
          state.allGoods.splice(i, 1);
        }
      });
      state.allGoodsBatchSn.filter((item) => item.batch_sn != data.batch_sn);
      emit("update:value", state.allGoods);
      emit("change", state.allGoods);
    };

    onMounted(() => {
      getCodeBatchsOptions();
      initData(search.value);
      is_select();
    });
    return {
      list,
      change,
      batchSn,
      columns,
      ...toRefs(state),
      search,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      addSubmit,
      selectGoods,
      is_select,
      close,
    };
  },
};
</script>